import { render, staticRenderFns } from "./MessListMessageTextEdit.vue?vue&type=template&id=f96af47e&scoped=true&"
import script from "./MessListMessageTextEdit.vue?vue&type=script&lang=js&"
export * from "./MessListMessageTextEdit.vue?vue&type=script&lang=js&"
import style0 from "./MessListMessageTextEdit.vue?vue&type=style&index=0&id=f96af47e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96af47e",
  null
  
)

export default component.exports